/* eslint-disable react/display-name */
import React from "react";
import {
  Container,
  Col,
  Row,
  Input,
  InputGroup,
  InputGroupText,
  Table,
  Card,
  CardBody,
} from "reactstrap";
import InputGroupAddon from "components/InputGroupAddon/InputGroupAddon";
import SideBarToggle from "../../Common/SideBarToggle";
import PropTypes from "prop-types";
import { translate } from "react-multi-lang";
import compose from "compose-function";
import { connect } from "react-redux";
import { Button } from "components";
import CreatTeamModal from "../../Modals/CreateTeamModal";
import BreadCrumbComponent from "../../Common/BreadCrumbComponent";
import { confirmPermissions } from "../../../../helpers/Utility";
import LoaderIcon from "../../../../assets/img/Loader.gif";
import ReactTable from "react-table";
import { getTeams } from "../../../../actions/teamAction";

function TeamPage(props) {
  const permissions = props.wholeTeamsData
    ? props.wholeTeamsData.permission
    : [];
  const data = props.teamsData ? props.teamsData : [];
  /*-------react table header------------ */
  const headers = {
    Name_Team: props.t("teams.TABLE_TITLE"),
    members: "Members",
    description: "Description",
    status: "Status",
  };
  return (
    <div>
      {props.showCreateTeamModal && (
        <CreatTeamModal
          isOpen={props.showCreateTeamModal}
          handleModal={props.handleModal}
          customerId={props.customerId}
          meta={props.stateValues.meta}
        />
      )}
      <div className="full-page-content">
        <div className="login-page">
          <Container>
            <Row className="mt-4 d-lg-none sidebar-btn-landscape">
              <Col>
                <SideBarToggle />
              </Col>
              <Col className="d-md-none">
                {confirmPermissions(permissions, "isTeamCreatable") && (
                  <Button
                    color="primary"
                    onClick={() =>
                      this.setState({
                        showCreateTeamModal: true,
                      })
                    }
                    className="mobile-button"
                  >
                    {props.t("teams.CREATE_TEAM")}
                  </Button>
                )}
              </Col>
            </Row>
            <Row className="mt-4">
              <Col lg={2} md={2} xs={6} className="padding-one">
                <p className="font-weight-bold text-muted">
                  {props.t("teams.TITLE")}
                </p>
              </Col>
              <Col lg={5} md={5} xs={6} className="mr-auto padding-two">
                <InputGroup className="no-border">
                  <Input
                    id="myInput"
                    placeholder={props.t("teams.SEARCH")}
                    className="search-bar-css shadow-css"
                    onKeyUp={(e) => props.searchTeam(e)}
                  />
                  <InputGroupAddon addonType="append">
                    <InputGroupText className="search-bar-css icon-css shadow-css">
                      <i className="now-ui-icons ui-1_zoom-bold" />
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </Col>
              <Col
                lg={2}
                md={2}
                xs={12}
                sm={12}
                className="offset-sm-2 offset-xs-2 order-first order-lg-last order-md-last"
              >
                {confirmPermissions(permissions, "isTeamCreatable") && (
                  <Button
                    color="primary"
                    onClick={() => props.showModal()}
                    className="create-team-button"
                  >
                    <span className="font-weight-bold">
                      {props.t("teams.CREATE_TEAM")}
                    </span>
                  </Button>
                )}
              </Col>
            </Row>
            <Row>
              <Col lg={6} md={6} xs={12} className="">
                <div>
                  <BreadCrumbComponent
                    active="Teams"
                    nonActive1={props.customerName}
                    nonActive1Href={
                      "/dashboard/organisationDashboard/" + props.customerId
                    }
                    nonActive2="Organisations"
                    nonActive2Href={"/dashboard/organisations"}
                  />
                </div>
              </Col>
            </Row>
            <Card className="mt-4">
              <CardBody>
                <ReactTable
                  loading={!props.stateValues.isRequesting ? false : true}
                  loadingText={"Argos..."}
                  className="cursor-pointer"
                  getTrProps={(state, row) => ({
                    onClick: (e) => props.showDashboard(row.original.status.id),
                  })}
                  data={data}
                  columns={[
                    {
                      columns: [
                        {
                          Header: headers.Name_Team,
                          accessor: "Name_Team",
                          Cell: (row) => (
                            <div>
                              <div className="widget-content p-0">
                                <div className="widget-content-wrapper">
                                  {row.value}
                                </div>
                              </div>
                            </div>
                          ),
                        },
                        {
                          sortable: false,
                          Header: headers.members,
                          accessor: "members",
                          Cell: (row) => (
                            <div>
                              <div className="widget-content p-0">
                                <div className="widget-content-wrapper">
                                  {row.value}
                                </div>
                              </div>
                            </div>
                          ),
                        },
                        {
                          sortable: false,
                          Header: headers.description,
                          accessor: "description",
                          Cell: (row) => (
                            <div>
                              <div className="widget-content p-0">
                                <div className="widget-content-wrapper">
                                  <div className="">{row.value}</div>
                                </div>
                              </div>
                            </div>
                          ),
                        },
                        {
                          sortable: false,
                          Header: headers.status,
                          accessor: "status",
                          Cell: (row) => (
                            <div>
                              <div className="widget-content p-0">
                                <div className="widget-content-wrapper">
                                  <div className="ml-5">
                                    {row.value.status ? (
                                      <span className="badge badge-primary">
                                        active
                                      </span>
                                    ) : (
                                      <span className="badge badge-secondary background-style">
                                        inactive
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ),
                        },
                      ],
                    },
                  ]}
                  manual
                  pages={props.stateValues.meta.pageTotal}
                  defaultPageSize={props.stateValues.meta.pageSize}
                  pageSizeOptions={props.stateValues.meta.pageSizeOptions}
                  onFetchData={(state, instance) => {
                    let qString;
                    if (state.sorted.length) {
                      qString = `?pageSize=${state.pageSize}&pageIndex=${
                        state.page
                      }&field=${state.sorted[0].id}&order=${
                        state.sorted[0].desc ? "desc" : "asc"
                      }`;
                    } else {
                      qString = `?pageSize=${state.pageSize}&pageIndex=${state.page}`;
                    }
                    if (props.customerId && qString) {
                      props.dispatch(getTeams(props.customerId, qString));
                    }
                  }}
                />
              </CardBody>
            </Card>
          </Container>
        </div>
      </div>
    </div>
  );
}
TeamPage.propTypes = {
  searchTeam: PropTypes.func,
  teamsData: PropTypes.array,
  wholeTeamsData: PropTypes.object,
  language: PropTypes.object,
  customerId: PropTypes.string,
  customerName: PropTypes.string,
  deleteTeam: PropTypes.func,
  editTeam: PropTypes.func,
  showCreateTeamModal: PropTypes.bool,
  handleModal: PropTypes.func,
  initialValues: PropTypes.object,
  showDashboard: PropTypes.func,
  stateValues: PropTypes.object,
};
export default compose(translate, connect())(TeamPage);
